import React, { Component } from "react";
import CommonCharts from "../../../components/Charts";
import { defaultDate } from "../../../../../common/jsLibs";
import API_URL from "../../../../../common/url";
import ExportUtil from "../../../../../common/ExportUtil";

class Charts extends Component {
    constructor(props) {
        super(props);
    }

    handleClick = () => {
        const { searchParams } = this.props;
        const defaultDateObj = defaultDate();
        const { beginDateDefault, endDateDefault } = defaultDateObj;
        const { beginDate, endDate } = searchParams || {};
        searchParams.beginDate = beginDate ? beginDate : beginDateDefault;
        searchParams.endDate = endDate ? endDate : endDateDefault;
        let url = API_URL.home.exportBAHistogram;
        ExportUtil.export({ ...searchParams }, null, url);
    };

    render() {
        const {
            canApplyAmountList,
            canNotApplyAmountList,
            grossAmountList,
            receivingAmountList,
            height,
            filename,
        } = this.props;
        const categories = [];
        const canApplyAmountData = [];
        const canNotApplyAmountData = [];
        const grossAmountData = [];
        const receivingAmountData = [];
        (canApplyAmountList || []).forEach((item) => {
            const { userCompellation, amount, userId } = item;
            if (userId) {
                categories.push(userCompellation);
                canApplyAmountData.push(amount);
            }
        });
        (canNotApplyAmountList || []).forEach((item) => {
            const { amount, userId } = item;
            if (userId) {
                canNotApplyAmountData.push(amount);
            }
        });
        (grossAmountList || []).forEach((item) => {
            const { amount, userId } = item;
            if (userId) {
                grossAmountData.push(amount);
            }
        });
        (receivingAmountList || []).forEach((item) => {
            const { amount, userId } = item;
            if (userId) {
                receivingAmountData.push(amount);
            }
        });
        return (
            <div className="chart-content">
                <p className="RequestSheet-title">
                    已开票总金额、确认可请款金额、延时不可请款金额
                </p>
                <CommonCharts
                    height={height}
                    filename={filename}
                    xAxis={{
                        categories,
                        crosshair: true,
                    }}
                    yAxis={[
                        {
                            title: {
                                text: "单位：万元/人民币",
                            },
                            reversedStacks: true, // 默认值
                        },
                    ]}
                    type="column"
                    plotOptions={{
                        series: {
                            stacking: "normal",
                        },
                        column: {
                            dataLabels: {
                                enabled: true,
                                inside: true,
                                style: { color: 'black', textOutline: 'none' },
                            },
                        },
                    }}
                    series={[
                        {
                            name: "确认可请款金额",
                            data: canApplyAmountData,
                            color: "#83d7a6",
                        },
                        {
                            name: "延时不可请款金额",
                            data: canNotApplyAmountData,
                            color: "#687794",
                        },
                        {
                            name: "已开票总金额",
                            data: grossAmountData,
                            color: "#6b95f2",
                        },
                    ]}
                    onClick={this.handleClick}
                    fromRequestSheet={true}
                />
                <p className="RequestSheet-title">已回款金额</p>
                <CommonCharts
                    height={height}
                    filename={filename}
                    xAxis={{
                        categories,
                        crosshair: true,
                    }}
                    yAxis={[
                        {
                            title: {
                                text: "单位：万元/人民币",
                            },
                        },
                    ]}
                    series={[
                        {
                            name: "已回款金额",
                            type: "column",
                            data: receivingAmountData,
                        },
                    ]}
                    plotOptions={{
                        column: {
                            dataLabels: {
                                enabled: true,
                                inside: true,
                                style: { color: 'black', textOutline: 'none' },
                            },
                        },
                    }}
                    onClick={this.handleClick}
                    fromRequestSheet={true}
                />
            </div>
        );
    }
}

export default Charts;



// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/RequestSheet/HistogramBrokenLine/Charts.js